import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    AngularJsMaterialModuleName,
    LoaderModuleName,
    MainModuleName,
    MainServiceModuleName,
    OpportunityNotificationModuleName
} from "../utils/names/requiredModulesNames";
import {AngularMaterialTableModuleName, OpportunitiesServiceModuleName} from "../utils/names/optionalModuleNames";


export const MainModuleConfiguration = new RestrictedRouteModuleConfiguration(
    MainModuleName,
    [
        OpportunitiesServiceModuleName,
        LoaderModuleName,
        AngularMaterialTableModuleName,
        MainServiceModuleName,
        AngularJsMaterialModuleName,
        OpportunityNotificationModuleName
    ],
    [],
    [],
    [],
    [],
);